import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'
import styled from 'styled-components'

import {
  CustomInput,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
  FormText,
} from 'reactstrap'

import { status, TINYMCE_APIKEY } from '../../constants'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ConsentLogsTable from '../../components/table-consent-logs'
import { createStructuredSelector } from 'reselect'
import { authSelector, consentLogSelector } from './../../selectors'
import { authAction, consentLogAction } from './../../actions/'
import { Editor } from '@tinymce/tinymce-react';
import get from 'lodash/get'
import { getListUser } from '../../selectors/employee/employee-selector'
import { employeeAction } from '../../actions/employee'
const url = 'https://www.materialui.co/materialIcons/navigation/cancel_black_192x192.png'

const header = ['Employee', 'Type', 'LOB', 'Document', 'Status', 'Date']
class ConsentManagementForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
      employee_type: true,
      candidate_type: false,
      consentlogs: [],
    }

  }
  componentDidMount() {

    const access_token = localStorage.getItem('access_token')
    this.props.getEmployeeList(access_token)
  }
  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'user_type') === 'Employee') {
      this.setState({
        employee_type: true,
        candidate_type: false,
        user_type: 'Employee',
      })
    } if (_.get(nextProps, 'user_type') === 'Candidate') {
      this.setState({
        employee_type: false,
        candidate_type: true,
        user_type: 'Candidate',
      })
    }
    if (get(nextProps, 'listCompanyData')) {
      this.setState({
        consentlogs: get(nextProps, 'listCompanyData'),
      })

    }
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab })
    }
  }
  render() {
    return (
      /* eslint no-underscore-dangle: 0 */
      <Background>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '1' })}
              onClick={() => { this.toggle('1') }}
            >
              Consent Management
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '2' })}
              onClick={() => { this.toggle('2') }}
              disabled={_.get(this.props, 'edit') === undefined}
            >
              Users Logs
            </NavLink>
          </NavItem>
          <Image
            src={url}
            onClick={_.get(this.props, 'confirm') === 'ConsentManagementForm' ? this.props.cancelForm : this.props.showDiscard}
          />
        </Nav>
        <TabContent activeTab={this.state.activeTab} >
          <TabPane tabId="1">
            <ContainerInTab>
              <Row>
                <Col sm="12">
                  <Form>
                    <FormGroup>
                      <Container >
                        <Row style={{ marginTop: 10 }}>
                          <Col sm={3}>
                            <Label >Title</Label>
                          </Col>
                          <Col sm={9}>
                            <InputField
                              invalid={_.get(this.props, 'title') === ''}
                              name="title"
                              disabled={!_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined}
                              placeholder="Title"
                              value={_.get(this.props, 'title')}
                              onChange={this.props.handleInput}
                            />
                          </Col>
                        </Row>
                        <Row style={{ marginTop: 10 }}>
                          <Col sm={3}>
                            <Label >User type</Label>
                          </Col>
                          <Col sm={9}>
                            <CustomRadioInput
                              type="radio"
                              id="employee"
                              name="user_type"
                              label="Employee"
                              disabled={!_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined}
                              value="Employee"
                              checked={this.props.user_type === 'Employee'}
                              onChange={this.props.handleInput}
                            />
                            <CustomRadioInput
                              type="radio"
                              id="candidate"
                              name="user_type"
                              label="Candidate"
                              value="Candidate"
                              disabled={!_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined}
                              checked={this.props.user_type === 'Candidate'}
                              onChange={this.props.handleInput}
                            />
                          </Col>
                        </Row>
                        <Row style={{ marginTop: 10 }}>
                          <Col sm={3}>
                            <Label >Need Acceptance</Label>
                          </Col>
                          <Col sm={9}>
                            {/* <InputField
                            name="company"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            placeholder="Enter Acceptance"
                            value={ _.get(this.props, 'company') }
                            onChange={ this.props.handleInput }
                          /> */}
                          </Col>
                        </Row>
                        <Row style={{ marginTop: 10 }}>
                          <Col sm={3}>
                            <Label>Description</Label>
                          </Col>
                          <Col sm={9}>
                            <Editor
                              value={_.get(this.props, 'description')}
                              apiKey={process.env.REACT_APP_TINYMCE_APIKEY}
                              disabled={!_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined}
                              init={{
                                height: 500,
                                menubar: false,
                                plugins: [
                                  'advlist autolink lists link image charmap print preview anchor',
                                  'searchreplace visualblocks code fullscreen',
                                  'insertdatetime media table paste code help wordcount'
                                ],
                                toolbar:
                                  'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
                              }}
                              onEditorChange={this.props.handleModelChange}
                            />
                          </Col>
                        </Row>
                        <Row style={{ marginTop: 10 }}>
                          <Col sm={3}>
                            <Label>Parameters</Label>
                          </Col>
                          <Col sm={9}>
                            <FormText color="muted">
                              For Employees Title type: &#123;User_Title&#125; in any spacing of the text<br></br>
                              For Employees First name type: &#123;User_FirstName&#125; in any spacing of the text<br></br>
                              For Employees Last name type: &#123;User_LastName&#125; in any spacing of the text<br></br>
                              For Employees ID type: &#123;User_ID&#125; in any spacing of the text<br></br>
                              For Employees LOB type: &#123;User_Company&#125; in any spacing of the text
                            </FormText>
                          </Col>
                        </Row>
                        {
                          _.get(this.props, 'create') === undefined &&
                          <Row style={{ marginTop: 10 }}>
                            <Col sm={3}><Label>Status</Label></Col>
                            <Col sm={9}>
                              <CustomInputField
                                type="select"
                                id="is_active"
                                name="is_active"
                                disabled={!_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined}
                                value={get(this.props, 'is_active')}
                                onChange={this.props.handleInput}
                              >
                                {
                                  status.map((s, key) => <option key={key} value={s.value}>{s.label}</option>)
                                }
                              </CustomInputField>
                            </Col>
                          </Row>
                        }
                      </Container>

                    </FormGroup>
                    <Right>
                      {_.get(this.props, 'button')}
                    </Right>

                  </Form>
                </Col>
              </Row>
            </ContainerInTab>
          </TabPane>
          <TabPane tabId="2">
            <ConsentLogsTable
              header={header}
              data={this.state.consentlogs.filter((user) => { return user.document_code === this.props.id })}
              // handleClickEdit={ this.handleClickEdit }
              span={get(this.props, 'span')}
              table={this.props.table}
              employeeList={this.props.employeeList}
              document_code={this.props.id}
              consent={this.props.consent}
              masterData={this.props.masterData}
            />
          </TabPane>
        </TabContent>
      </Background>
    )
  }
}

ConsentManagementForm.propTypes = {
  handleInput: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
  handleModelChange: PropTypes.func.isRequired,
  handleClickEdit: PropTypes.func.isRequired,
  handleSpan: PropTypes.array.isRequired,
  listConsentLog: PropTypes.func.isRequired,
  getEmployeeList: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  listCompanyData: consentLogSelector.getConsentLog,
  employeeList: getListUser,
  authData: authSelector.getAuth,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  listConsentLog: consentLogAction.getConsentLogByDocCode,
  getEmployeeList: employeeAction.getUser,
  getAuth: authAction.auth,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ConsentManagementForm)

const Right = styled.div`
  background-color: white;
  padding: 10px;
  text-align: right;
`
const Background = styled.div`
  background-color: white;
  padding: 10px;
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`
const InputField = styled(Input)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`
const Image = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 10px;
`
const CustomInputField = styled(CustomInput)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`
const CustomRadioInput = styled(CustomInput)`
  font-family: 'Gotham-Bold' !important;
`
const ContainerInTab = styled(Container)`
overflow-y: scroll;
height: calc(100vh - 200px);
overflow-x:hidden;
`


// WEBPACK FOOTER //
// ./src/components/consent-management/index.js